import { createBrowserHistory } from "history";

/**
 *  I used a custom history object instead of the built into React Router to enable redirecting users from outside React components, for example from the user actions after successful login/logout/401 response status.
 */
export const history = createBrowserHistory();
